import SettingsIcon from '@material-ui/icons/Settings';
import {
    ContainerFieldsList,
    CustomBreadcrumbs,
    CustomSelectInput,
} from 'candy-commons-components';
import React from 'react';
import { useSelector } from 'react-redux';
import {
    ArrayInput,
    BooleanInput,
    Create,
    ImageField,
    NumberInput,
    SimpleForm,
    SimpleFormIterator,
    TextInput,
    required,
    useTranslate,
} from 'react-admin';
import ImageInput from '../../components/ImageInput';
import loadingType from '../../data/loadingType.json';
import enrollmentTypeOptions from '../appliance-wake-up/applianceWakeUp.mock';
import {
    getApplianceTypes,
    getBrands,
    getSeries,
    getSeriesVersion,
} from '../../selectors/cmsConfig';

const RcActivationScreenCreate = (props) => {
    const translation = useTranslate();
    const applianceTypes = useSelector(getApplianceTypes);
    const brands = useSelector(getBrands);
    const series = useSelector(getSeries);
    const seriesVersion = useSelector(getSeriesVersion);

    const breadcrumbsData = [
        {
            text: translation('resources.rc-activation-screen.name'),
            url: 'rc-activation-screen',
            icon: <SettingsIcon />,
        },
        {
            text: translation('resources.rc-activation-screen.create.name'),
            url: '',
        },
    ];

    return (
        <>
            <CustomBreadcrumbs data={breadcrumbsData} />
            <Create {...props}>
                <SimpleForm redirect="list">
                    <ContainerFieldsList>
                        <CustomSelectInput
                            allowEmpty
                            source="applianceType"
                            choices={applianceTypes}
                        />
                        <CustomSelectInput
                            allowEmpty
                            source="brand"
                            choices={brands}
                        />
                        <CustomSelectInput
                            allowEmpty
                            source="series"
                            choices={series}
                        />
                        <CustomSelectInput
                            allowEmpty
                            source="seriesVersion"
                            choices={seriesVersion}
                        />
                        <CustomSelectInput
                            allowEmpty
                            source="loadingType"
                            choices={loadingType}
                        />
                        <CustomSelectInput
                            allowEmpty
                            source="enrollmentType"
                            label="Enrollment Type"
                            choices={enrollmentTypeOptions}
                            translateChoice={false}
                        />
                        <NumberInput source="priority" initialValue={0} />
                        <BooleanInput
                            source="isPublished"
                            initialValue={false}
                        />
                    </ContainerFieldsList>
                    <ArrayInput source="steps" validate={required()}>
                        <SimpleFormIterator>
                            <TextInput source="title" label="Title" />
                            <ArrayInput source="descriptions">
                                <SimpleFormIterator>
                                    <TextInput
                                        source="description"
                                        label="Description"
                                    />
                                </SimpleFormIterator>
                            </ArrayInput>
                            <ImageInput
                                source="imagePath"
                                label="Image"
                                accept="image/*"
                                placeholder={<p>Drop your image here</p>}
                            >
                                <ImageField source="src" title="title" />
                            </ImageInput>
                        </SimpleFormIterator>
                    </ArrayInput>
                </SimpleForm>
            </Create>
        </>
    );
};

export default RcActivationScreenCreate;
